export default "__VITE_ASSET__BMr2pytc__"